<template>
  <div class="selectStorageStyle">
    <v-select
      v-model="inputedValue"
      item-text="label"
      item-value="value"
      :items="items"
      dense
      multiple
      outlined
      return-object
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.input_unselected_2')"
      :height="height"
      :no-data-text="$t('common.common_not-storage-register')"
      clearable
    >
    </v-select>
  </div>
</template>

<script>
import { storageUtil } from '@/util'
export default {
  components: {
    //
  },
  props: {
    value: {
      type: Array,
      require: false,
      default: () => []
    },
    height: { default: '32px' },
    hasDefault: { default: true }
  },
  data: () => ({
    items: []
  }),
  async created() {
    const itemsTmp = await storageUtil.getStorageIdNameList()
    this.items = itemsTmp ? itemsTmp.data : []
    if (itemsTmp && itemsTmp.data && this.hasDefault) {
      this.inputedValue = [itemsTmp.data[0]]
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.selectStorageStyle {
  width: 100%;
}
</style>
